import { useCreateEntity } from '@abaninja/util-store';

import { authorize } from '../organizations';

export const useAuthorizeStore = () => useCreateEntity(authorize);
